import { PaymentAction } from '../types';

type ReturnType = Pick<
  PaymentAction,
  'paymentActionType' | 'paymentActionRequired' | 'paymentActionUrl'
> & {
  bannerMessage: string;
};

export const handlePaymentAction = (
  subscriptionMetadata: PaymentAction[],
): ReturnType => {
  // can't access property "find", e is undefined 
  const sequence = subscriptionMetadata?.find(
    (obj) => obj.application === 'sequence',
  );
  const leadFinder = subscriptionMetadata?.find(
    (obj) => obj.application === 'lead-finder',
  );
  const inboxAnalyzer = subscriptionMetadata?.find(
    (obj) => obj.application === 'inbox-analyzer',
  );

  let bannerMessage = '';

  if (sequence?.paymentActionRequired) {
    bannerMessage = 'initial_payment_pending_text_one';
  } else if (leadFinder?.paymentActionRequired) {
    bannerMessage = 'initial_payment_pending_text_one_lead';
  } else if (inboxAnalyzer?.paymentActionRequired) {
    bannerMessage = 'initial_payment_pending_text_one_inbox';
  }

  return {
    paymentActionRequired:
      sequence?.paymentActionRequired ||
      leadFinder?.paymentActionRequired ||
      inboxAnalyzer?.paymentActionRequired,
    paymentActionType:
      sequence?.paymentActionType ||
      leadFinder?.paymentActionType ||
      inboxAnalyzer?.paymentActionType,
    paymentActionUrl:
      sequence?.paymentActionUrl ||
      leadFinder?.paymentActionUrl ||
      inboxAnalyzer?.paymentActionUrl,
    bannerMessage,
  };
};
